module.exports = __webpack_public_path__ + "static/media/Template_urgent_sellout.ee05c7b9.csv";